export default {
  common: {
    learnMore: '了解更多',
    seeMore: '查看更多',
  },
  navbar: {
    home: '首页',
    abortGreatWall: '关于长城',
    companyIntroduction: '公司简介',
    developmentHistory: '发展历程',
    honoraryQualifications: '荣誉资质',
    corporateCulture: '企业文化',
    productServices: '产品服务',
    roundWireProducts: '圆线产品',
    flatWireProducts: '扁线产品',
    applicationArea: '应用领域',
    partners: '合作伙伴',
    greatWallPower:'长城力量',
    researchStrength:'科研力量',
    advancedEquipment:'先进设备',
    qualityAssurance:'品质保障',
    authoritativeCertification:'权威认证',
    newsInformation: '新闻资讯',
    companyInformation: '公司资讯',
    industryNews: '行业新闻',
    joinUs: '加入我们',
    contactUs: '联系我们',
    recruitmentInformation: '招聘信息',
  },
  footer: {
    abortUs: '关于我们',
    phone: '电话',
    address: '地址',
    email: '邮件',
    facsimile: '传真',
    addressText: '浙江湖州市练市长城大道东1号',
    website: '网址',
    shCode: '股 票 代 码'
  },
  home: {
    industrialMotorField: '工业电机领域',
    newEnergyField: '新能源领域',
    electricToolField: '电动工具领域',
    automotiveElectricalField: '汽车电器领域',
    householdAppliancesField: '家用电器领域',
    instrumentationField: '仪器仪表领域',
    page3Title: '品牌介绍',
    page4Title: '新闻资讯',
    page5Title: '合作伙伴'
  },
  abort: {
    titleText1: '坚持以科技创新为驱动力',
    titleText2: '不断追求卓越品质',
    titleText3: '致力于提供世界级优质产品与服务',
    corporateCultureTitle1: '核心价值观',
    corporateCultureTitle2: '企业愿景',
    corporateCultureTitle3: '企业使命',
    corporateCultureTitle4: '经营宗旨',
    corporateCultureTag1: '诚信，责任',
    corporateCultureTag2: '团结，创新',
    corporateCultureTag3: '顺势而为，乘胜前进',
    corporateCultureTag4: '打造世界品牌',
    corporateCultureTag5: '争做全球NO.1',
    corporateCultureTag6: '以科技为驱动',
    corporateCultureTag7: '共建绿色未来',
    corporateCultureTag8: '为客户和股东创造价值',
    corporateCultureTag9: '绿色，高效',
    corporateCultureTag10: '讲原则',
  },
  services: {
    roundTitle: '圆线产品规格',
    flatTitle: '扁线产品规格',
    roundTableTitle1: '产品型号',
    roundTableTitle2: '产品名称',
    roundTableTitle3: '国家标准',
    roundTableTitle4: 'IEC标准',
    roundTableTitle5: 'NEMA标准',
    explain: '说明',
  },
  power: {
    researchStrength1: '长城科技于2014年建立了院士专家工作站，并与西安交通大学、浙江工业大学机械工程学院等知名院校建立了产学研协作关系，先后承担了10余项国家级、省级科研项目。',
    researchStrength2: '公司齐聚多名高级工程师，拥有雄厚科研实力，于2020年建立长城科技研究院，为取得自主先进创新成果提供强有力的科技支撑；拥有专利200余项，参与起草国家和行业标准40余项。',
    equipment1: '奥地利MAG漆包生产线',
    equipment2: '自动下料漆包生产线',
    equipment3: 'NIEHOFF双头大拉机',
    equipment4: '自动换盘0.10-0.30mm小拉机',
    equipment5: '自动换盘多头小线漆包机',
    equipment6: '自动化仓储系统',
    authoritativeText: '通过了ISO9001、IATF16949、ISO14001、ISO45001等体系认证以及美国UL安全认证，符合欧盟RoHS要求'
  },
  news: {
    tab1: '公司资讯',
    tab2: '行业新闻',
    firstPage: '首页',
    endPage: '尾页',
    prevPage: '上一页',
    nextPage: '下一页',
    date: '时间',
    prevArticle: '上一篇',
    nextArticle: '下一篇'
  },
  contact: {
    creatTime: '发布时间',
    department: '所属部门',
    recruitmentNumber: '招聘人数',
    workLocation: '工作地点',
    jobNature: '工作性质',
    jobResponsibilities: '岗位职责',
    jobRequirements: '任职要求',
    clickExpand: '点我展开',
    clickShrink: '点我收缩',
    applyOnline: '在线应聘',
    name: '姓名',
    gender: '性别',
    birthDate: '出生年月',
    location: '户口所在地',
    marriage: '婚否',
    politicalLandscape: '政治面貌',
    qualification: '学历',
    professionalTitle: '职称或资质',
    graduationInstitution: '毕业院校',
    major: '专业',
    graduationDate: '毕业时间',
    phone: '联系电话',
    specialties: '特长',
    email: 'Email',
    languageLevel: '外语水平',
    postalCode: '邮编',
    address: '地址',
    workExperience: '工作经验',
    selfIntroduction: '自我介绍',
    jobApplication: '应聘职位',
    male: '男',
    female: '女',
    yes: '是',
    no: '否',
    qualification1: '初中及以下',
    qualification2: '高中',
    qualification3: '中技/中专',
    qualification4: '大专',
    qualification5: '本科',
    qualification6: '硕士',
    qualification7: '博士',
    qualification8: 'MBA/EMBA',
    rules1: '请输入姓名',
    rules2: '请选择性别',
    rules3: '请输入出生年月',
    rules4: '请输入户口所在地',
    rules5: '请选择婚否',
    rules6: '请输入政治面貌',
    rules7: '请选择学历',
    rules8: '请输入职称或资质',
    rules9: '请输入毕业院校',
    rules10: '请输入专业',
    rules11: '请输入毕业时间',
    rules12: '请输入联系电话',
    rules13: '请输入特长',
    rules14: '请输入Email',
    rules15: '请输入外语水平',
    rules16: '请输入邮编',
    rules17: '请输入地址',
    rules18: '请输入工作经验',
    rules19: '请输入自我介绍',
    rules20: '请输入应聘职位',
    submit: '提交信息'
  }
}
    


// WEBPACK FOOTER //
// ./src/lang/system/zh.js